import { i18n } from '@/locales';

const postcode = {
  getMessage: function() {
    return i18n.t('Please provide a valid UK postcode');
  },
  validate: function (value) {
    const stripWhiteSpace = value.replace(/\s/g,'');
    // eslint-disable-next-line max-len
    const fullPostcodeRegex = /^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i.test(stripWhiteSpace);
    const sectorPostcodeRegex = /^[a-z]{1,2}[1-9][a-z\d]?\s*\d/i.test(stripWhiteSpace);
    const validOutcodeRegex = /^[a-z]{1,2}[1-9][a-z\d]?$/i.test(stripWhiteSpace);
    const districtPostcodeRegex = /^[a-z]{1}\d$/i.test(stripWhiteSpace);
    const postcodeLength = stripWhiteSpace.length <= 7;
    return postcodeLength && (districtPostcodeRegex || sectorPostcodeRegex || validOutcodeRegex || fullPostcodeRegex);
  }
}

export default postcode;
